export default __webpack_public_path__ + "static/media/fp-booking-site.4fb73141.svg";